import { render, staticRenderFns } from "./PicklTypeInsights.vue?vue&type=template&id=017863b0&"
import script from "./PicklTypeInsights.vue?vue&type=script&lang=js&"
export * from "./PicklTypeInsights.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2332429520/src/pickl-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('017863b0')) {
      api.createRecord('017863b0', component.options)
    } else {
      api.reload('017863b0', component.options)
    }
    module.hot.accept("./PicklTypeInsights.vue?vue&type=template&id=017863b0&", function () {
      api.rerender('017863b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Brand/Reports/PicklTypeInsights.vue"
export default component.exports